<template id="rfm-score">
    <section>
        <div class="row">
            <div class="col-md-11 col-lg-11 text-center mt-3 ml-3">
                <div class="card">
                    <div class="card-header d-flex justify-content-between" >
                        <div class="">RFM Score</div>
                        <a v-on:click="commentBox(r1c1)" class="txt-color-white right-padding-50">
                            <i class="fa fa-lg fa-comments"></i>
                        </a>
                    </div>
                    <div class="card-body">
                        <div id="chart" ref="chart" style="height:600px">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="comment-box" @ok="postAnnotation()" :title="annotationTitle">
            <b-form-group label="Comment">
                <textarea rows="3" cols="50" v-model="cmnt" placeholder="Write a comment..."></textarea>
            </b-form-group>
        </b-modal>
    </section>
</template>
<script>
import * as jQuery from "jquery";
import {OCPU} from '@/library/opencpu'
import axios from 'axios'
import {VizChartInfo} from '@/models'

let ocpu = new OCPU()
    export default {
        name: "rfm-score",

        data: () => ({
            showModal: false,
            cmnt: "",
            annotations: [],
            searching: false,
            annotationTitle: '',
            r1c1: new VizChartInfo("R1C1", {}, {}, false, []),
        }),

        computed: {},
        created() {
            this.loadSummary()
        },
        methods: {

            commentBox: function (what) {
                this.cmt = '';
                this.pg = what.menu;
                this.section = what.name;
                this.annotationHeader = "User Annotations";
                this.annotationTitle = this.annotationHeader + '->' + this.pg + '->' + this.section
                this.$bvModal.show('comment-box')
            },
            postAnnotation: function () {
                const url = '/api/annotation';
                const data = {
                    userId: 1,
                    userName: "Admin",
                    page: this.pg,
                    section: this.section,
                    comment: this.cmnt
                };
                axios.post(url, data)
                    .then(this.loadAnnotations(), e => {
                        console.error('error in updating annotations', e)
                    })
                let menu = this.pg;
                let subMenu = this.section;
                console.log("the menus and submenus for Audit log is", menu, subMenu)
              console.log("r1c1",this.r1c1);


             // this.$commonFn.auditLog(menu, subMenu, "", "POST", "add comments", "Success")
            },
            loadAnnotations: function () {
                axios.get("/api/annotation")
                    .then(res => this.annotations = res.data)
            },

            loadSummary: function () {
                setTimeout(() => {
                    ocpu.seturl("http://139.59.58.160/ocpu/library/ffmretail/R");
                    let divId = this.$refs.chart
                    var req1 = jQuery(divId).rplot("bar_chart_rfm");
                    req1.fail(function(){
                        alert("R returned an error: " + req1.responseText);
                    });

                }, 500)
            }
        }
    }
</script>